import { Box } from '@factorialco/deprecated-design-system'
import { A3IncidenceFinanceCostCenterAssignmentFragment } from 'generated/resources/graphql'
import moment from 'moment'

import IncidenceDetailDataChangeLine from 'modules/bookkeepers/components/IncidenceDetailDataChangeLine'

interface DataChangeInfoProps {
  costCenters: A3IncidenceFinanceCostCenterAssignmentFragment[]
  incidenceStartDate: string
  targetAssignmentId: number
}

export const CostCenterChangeInfo = ({
  costCenters,
  incidenceStartDate,
  targetAssignmentId,
}: DataChangeInfoProps) => {
  const targetAssignment = costCenters.find((cc) => cc.id === targetAssignmentId)

  if (!targetAssignment || !targetAssignment.costCenter) {
    return null
  }

  const targetCostCenterId = targetAssignment.costCenter.id
  const incidenceDate = moment(incidenceStartDate)

  let previousAssignment: A3IncidenceFinanceCostCenterAssignmentFragment | undefined
  let currentAssignment: A3IncidenceFinanceCostCenterAssignmentFragment | undefined

  costCenters
    .filter((cc) => cc.costCenter?.id === targetCostCenterId)
    .forEach((costCenter) => {
      const assignmentStartDate = moment(costCenter.startDate)
      const assignmentEndDate = costCenter.endDate ? moment(costCenter.endDate) : null

      if (assignmentEndDate && assignmentEndDate.isBefore(incidenceDate, 'day')) {
        previousAssignment = costCenter
      } else if (assignmentStartDate.isSame(incidenceDate, 'day')) {
        currentAssignment = costCenter
      }
    })

  const parsePercentage = (percentage: number) => {
    return `${(percentage * 100).toFixed(0)}%`
  }

  if (currentAssignment?.percentage === previousAssignment?.percentage) {
    return null
  }

  return (
    <Box gap="s16" key={`cost_center_change_${targetAssignmentId}`}>
      <IncidenceDetailDataChangeLine
        label={targetAssignment.costCenter.name}
        oldValue={parsePercentage(previousAssignment?.percentage ?? 0)}
        newValue={parsePercentage(currentAssignment?.percentage ?? 0)}
      />
    </Box>
  )
}
